import { IChannel } from "../channels/typings";
import { ICompetition } from "../competitions/typings";
import { IMatch } from "../matches/typings";
import { ITeam } from "../teams/typings";

export type BroadcastAffiliationScope = 'match' | 'team' | 'competition' | 'channel';

export interface IBroadcastAffiliationTarget {
  id?: string;
  competition?: ICompetition | null;
  team?: ITeam | null;
  match?: IMatch | null;
}

export function getAffiliationScope(targets: IBroadcastAffiliationTarget[]): BroadcastAffiliationScope {
  if (!targets || targets.length === 0) return 'channel';
  if (targets.some((t) => t.match)) return 'match';
  if (targets.some((t) => t.team)) return 'team';
  if (targets.some((t) => t.competition)) return 'competition';
  return 'channel';
}

export interface IBroadcastAffiliation {
  id: string;
  locale: string;
  channel: IChannel;
  url: string;
  label?: string | null;
  useLabel: boolean;
  isEnabled: boolean;
  startDate?: string | null;
  endDate?: string | null;
  targets: IBroadcastAffiliationTarget[];
  createdAt: string;
  updatedAt: string;
}
